import { Routes } from "@angular/router";
import { InstructionPageComponent } from "./components/instruction/instruction-page/instruction-page.component";
import { LoginPageComponent } from "./components/authentication/login-page/login-page.component";
import { AuthGuard } from "./guards/auth-guard";
import { SkipLoginGuard } from "./guards/skip-login.guard";
import { InstructionDetailPageComponent } from "./components/instruction-details/instruction-detail-page/instruction-detail-page.component";
import { InstructionType } from "./models/instruction/instruction";
import { DashboardPageComponent } from "./components/dashboard/dashboard-page/dashboard-page.component";
import { SettingsPageComponent } from "./components/settings/settings-page/settings-page.component";
import { ForgotPasswordPageComponent } from "./components/authentication/forgot-password-page/forgot-password-page.component";
import { ResetPasswordHintPageComponent } from "./components/authentication/reset-password-hint-page/reset-password-hint-page.component";
import { ResetPasswordPageComponent } from "./components/authentication/reset-password-page/reset-password-page.component";

export interface RouteData {
  hideMenu?: boolean;
}

export const routes: Routes = [
  {
    path: "instructions",
    pathMatch: "full",
    component: InstructionPageComponent,
    data: {
      instructionType: "Unterweisung" as InstructionType,
    },
    canActivate: [AuthGuard],
  },
  {
    path: "instructions/:instruction/:instructionConfirmation",
    pathMatch: "full",
    component: InstructionDetailPageComponent,
    data: {},
    canActivate: [AuthGuard],
  },
  {
    path: "courses",
    pathMatch: "full",
    component: InstructionPageComponent,
    data: {
      instructionType: "Schulung" as InstructionType,
    },
    canActivate: [AuthGuard],
  },
  {
    path: "courses/:instruction/:instructionConfirmation",
    pathMatch: "full",
    component: InstructionDetailPageComponent,
    data: {},
    canActivate: [AuthGuard],
  },
  {
    path: "information",
    pathMatch: "full",
    component: InstructionPageComponent,
    data: {
      instructionType: "Information" as InstructionType,
    },
    canActivate: [AuthGuard],
  },
  {
    path: "information/:instruction/:instructionConfirmation",
    pathMatch: "full",
    component: InstructionDetailPageComponent,
    data: {},
    canActivate: [AuthGuard],
  },
  {
    path: "dashboard",
    pathMatch: "full",
    canActivate: [AuthGuard],
    component: DashboardPageComponent,
    data: {},
  },
  {
    path: "settings",
    pathMatch: "full",
    canActivate: [AuthGuard],
    component: SettingsPageComponent,
    data: {},
  },
  {
    path: "forgot-password",
    pathMatch: "full",
    canActivate: [SkipLoginGuard],
    component: ForgotPasswordPageComponent,
    data: {
      hideMenu: true,
    },
  },
  {
    path: "reset-password-hint",
    pathMatch: "full",
    canActivate: [SkipLoginGuard],
    component: ResetPasswordHintPageComponent,
    data: {
      hideMenu: true,
    },
  },
  {
    path: "reset-password",
    pathMatch: "full",
    canActivate: [SkipLoginGuard],
    component: ResetPasswordPageComponent,
    data: {
      hideMenu: true,
    },
  },
  {
    path: "login",
    pathMatch: "full",
    canActivate: [SkipLoginGuard],
    component: LoginPageComponent,
    data: {
      hideMenu: true, // is only passed outside of the route
      // https://stackoverflow.com/a/77737243
    },
  },
  {
    path: "**",
    redirectTo: "/dashboard",
  },
];
